import React, { useEffect, useState, useRef } from 'react';

import { Avatar, Box, Flex, Text, VStack } from '@chakra-ui/react';

import { formatMessageTime } from '../../utils/helpers';

import { useSelector } from 'react-redux';

const messages = [
  {
    id: 1,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: 'Hey John, just wanted to check in and see how things are going!',
    timestamp: '2026-05-29T02:14:45.016+00:00',
  },
  {
    id: 2,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: 'Hey! Things are good, thanks for reaching out.',
    timestamp: '2024-06-01T09:07:00.000Z',
  },
  {
    id: 3,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: 'Glad to hear that! Did you get a chance to review the proposal I sent?',
    timestamp: '2024-06-01T09:14:00.000Z',
  },
  {
    id: 4,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: 'Yes I did, looks solid. I had a couple of questions though.',
    timestamp: '2024-06-01T09:21:00.000Z',
  },
  {
    id: 5,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: 'Of course, go ahead! Happy to answer anything.',
    timestamp: '2024-06-01T09:28:00.000Z',
  },
  {
    id: 6,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: "What's the timeline looking like for the first delivery?",
    timestamp: '2024-06-01T09:35:00.000Z',
  },
  {
    id: 7,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: "We're targeting end of next month for the initial rollout.",
    timestamp: '2024-06-01T09:42:00.000Z',
  },
  {
    id: 8,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: 'That works for us. Can we schedule a call to discuss the details?',
    timestamp: '2024-06-01T09:49:00.000Z',
  },
  {
    id: 9,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: 'Absolutely! Are you free Thursday afternoon around 3 PM?',
    timestamp: '2024-06-01T09:56:00.000Z',
  },
  {
    id: 10,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: "Thursday works. Let's do 3:30 PM instead if that's okay.",
    timestamp: '2024-06-01T10:03:00.000Z',
  },
  {
    id: 11,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: "3:30 PM it is! I'll send a calendar invite shortly.",
    timestamp: '2024-06-01T10:10:00.000Z',
  },
  {
    id: 12,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: "Perfect, I'll keep an eye out for it.",
    timestamp: '2024-06-01T10:17:00.000Z',
  },
  {
    id: 13,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: 'Just sent the invite. Let me know if you need to add anyone else.',
    timestamp: '2024-06-01T10:24:00.000Z',
  },
  {
    id: 14,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: "Actually, can you add my colleague Sarah? She'll be joining us.",
    timestamp: '2024-06-01T10:31:00.000Z',
  },
  {
    id: 15,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: 'Done! Sarah has been added to the invite.',
    timestamp: '2024-06-01T10:38:00.000Z',
  },
  {
    id: 16,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: 'Great, appreciate it. One more thing — pricing is still negotiable right?',
    timestamp: '2024-06-01T10:45:00.000Z',
  },
  {
    id: 17,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: 'Yes, we have some flexibility there. We can definitely talk it through on the call.',
    timestamp: '2024-06-01T10:52:00.000Z',
  },
  {
    id: 18,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: 'Sounds good. Looking forward to Thursday!',
    timestamp: '2024-06-01T10:59:00.000Z',
  },
  {
    id: 19,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'outbound',
    body: 'Same here! Talk soon, John.',
    timestamp: '2024-06-01T11:06:00.000Z',
  },
  {
    id: 20,
    contact_id: 1,
    contact_name: 'John Doe',
    direction: 'inbound',
    body: 'Take care!',
    timestamp: '2024-06-01T11:13:00.000Z',
  },
];

const ThreadsArea = () => {
  const allThreads = useSelector((s) => s?.conversation?.threads);

  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [allThreads]);

  return (
    <Box>
      <Box
        width="100%"
        height="58vh"
        overflowY="auto"
        borderRadius="md"
        ref={scrollRef} // Add ref here
        css={{
          '&::-webkit-scrollbar': {
            width: '4px',
            height: '50vh',
          },
          '&::-webkit-scrollbar-track': {
            background: '#ffffff',
            borderRadius: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#E7B9B1',
            borderRadius: '8px',
          },
        }}
      >
        {allThreads && allThreads.length > 0 ? (
          allThreads
            .slice()
            .sort(
              (a, b) =>
                new Date(a.updatedAt).getTime() -
                new Date(b.updatedAt).getTime(),
            )
            .map((message) => {
              const timestamp = new Date(message.updatedAt);

              return (
                <Flex
                  key={message._id}
                  justify={
                    message.direction === 'outbound' ? 'flex-end' : 'flex-start'
                  }
                  mb={3}
                  pb={6}
                  mx={3}
                  pt={2}
                >
                  {/* {message.direction === 'inbound' && (
                    <Avatar size="sm" bg="orange.primary" mr={2} />
                  )} */}
                  <Box
                    bg={
                      message.direction === 'outbound'
                        ? '#FFF'
                        : 'orange.primary'
                    }
                    color="#000"
                    px={4}
                    py={2}
                    borderRadius="md"
                    maxW="60%"
                    boxShadow="lg"
                  >
                    <Text fontSize={14} fontWeight={400}>
                      {message.threadText}
                    </Text>
                    <Text fontSize={12} fontWeight={400} textAlign="end">
                      {formatMessageTime(timestamp)}
                    </Text>
                  </Box>
                </Flex>
              );
            })
        ) : (
          <Text textAlign="center" color="gray.500">
            No messages available
          </Text>
        )}
      </Box>

      {/* <Sender />
      <Receiver /> */}
    </Box>
  );
};
export default ThreadsArea;
